"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsymmetricEncryption = void 0;

var tweetnacl_zeemzo_1 = __importDefault(require("tweetnacl-zeemzo"));

var tweetnacl_util_1 = __importDefault(require("tweetnacl-util"));

var ed2curve_1 = require("ed2curve");

var stellar_base_1 = require("stellar-base");

var stellar_sdk_1 = require("stellar-sdk");

var AsymmetricEncryption =
/** @class */
function () {
  function AsymmetricEncryption() {}

  AsymmetricEncryption.NaclKeyPairFromStellarSecret = function (secretKeyInput) {
    var secretKey = stellar_base_1.StrKey.decodeEd25519SecretSeed(secretKeyInput);
    var keyPair = tweetnacl_zeemzo_1.default.sign.keyPair.fromSecretKey(secretKey);
    return {
      secretKey: tweetnacl_util_1.default.encodeBase64(keyPair.secretKey),
      publicKey: tweetnacl_util_1.default.encodeBase64(keyPair.publicKey)
    };
  };

  AsymmetricEncryption.NaclSecretKeyFromStellarSecret = function (secretKeyInput) {
    var secretKey = stellar_base_1.StrKey.decodeEd25519SecretSeed(secretKeyInput);
    return tweetnacl_util_1.default.encodeBase64(secretKey);
  };

  AsymmetricEncryption.NaclPublicKeyFromStellarPublic = function (publicKeyInput) {
    var publicKey = stellar_base_1.StrKey.decodeEd25519PublicKey(publicKeyInput);
    return tweetnacl_util_1.default.encodeBase64(publicKey);
  };

  AsymmetricEncryption.StellarKeyPairFromNaclSecret = function (secretKeyInput) {
    var some = Buffer.from(tweetnacl_util_1.default.decodeBase64(secretKeyInput));
    return stellar_sdk_1.Keypair.fromSecret(stellar_base_1.StrKey.encodeEd25519SecretSeed(some));
  };

  AsymmetricEncryption.StellarSecretKeyFromNaclSecret = function (secretKeyInput) {
    var some = Buffer.from(tweetnacl_util_1.default.decodeBase64(secretKeyInput));
    return stellar_base_1.StrKey.encodeEd25519SecretSeed(some);
  };

  AsymmetricEncryption.StellarPublicKeyFromNaclPublic = function (publicKeyInput) {
    var some = Buffer.from(tweetnacl_util_1.default.decodeBase64(publicKeyInput));
    return stellar_base_1.StrKey.encodeEd25519PublicKey(some);
  };

  AsymmetricEncryption.encrypt = function (dataValue, theirPublicKeyValue, mySecretKeyValue) {
    try {
      var data = tweetnacl_util_1.default.decodeUTF8(dataValue);
      var theirPublicKey = ed2curve_1.convertPublicKey(tweetnacl_util_1.default.decodeBase64(theirPublicKeyValue));
      var mySecretKey = ed2curve_1.convertSecretKey(tweetnacl_util_1.default.decodeBase64(mySecretKeyValue));
      var nonce = tweetnacl_zeemzo_1.default.randomBytes(tweetnacl_zeemzo_1.default.box.nonceLength);

      if (theirPublicKey == null) {
        return {
          data: tweetnacl_util_1.default.encodeBase64(data),
          nonce: tweetnacl_util_1.default.encodeBase64(nonce)
        };
      }

      data = tweetnacl_zeemzo_1.default.box(data, nonce, theirPublicKey, mySecretKey);
      return {
        data: tweetnacl_util_1.default.encodeBase64(data),
        nonce: tweetnacl_util_1.default.encodeBase64(nonce)
      };
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  };

  AsymmetricEncryption.decrypt = function (dataValue, nonceValue, theirPublicKeyValue, mySecretKeyValue) {
    try {
      var data = tweetnacl_util_1.default.decodeBase64(dataValue);
      var nonce = tweetnacl_util_1.default.decodeBase64(nonceValue);
      var theirPublicKey = ed2curve_1.convertPublicKey(tweetnacl_util_1.default.decodeBase64(theirPublicKeyValue));
      var mySecretKey = ed2curve_1.convertSecretKey(tweetnacl_util_1.default.decodeBase64(mySecretKeyValue));

      if (theirPublicKey == null) {
        return null;
      }

      var decryptedData = tweetnacl_zeemzo_1.default.box.open(data, nonce, theirPublicKey, mySecretKey);

      if (decryptedData == null) {
        throw new Error("failed opening nacl.box");
      }

      return tweetnacl_util_1.default.encodeUTF8(decryptedData);
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  };

  return AsymmetricEncryption;
}();

exports.AsymmetricEncryption = AsymmetricEncryption;